import { useTranslations } from "next-intl";
import { Headline, HeadlineProps } from "@carfax/web-ui/components/Headline";

interface IProps {}

export const HeadlineSection: React.FC<IProps> = () => {
  const t = useTranslations("page-account-dashboard");

  const headlineProps: HeadlineProps = {
    primaryText: t("sectionHeadline.title"),
    secondaryText: t("sectionHeadline.subtitle"),
    testSelector: "dashboard-title",
  };

  return (
    <section data-testid="account-dashboard-headline">
      <Headline {...headlineProps} />
    </section>
  );
};
